import { render } from "./ProjectSearchV2.vue?vue&type=template&id=546093de&scoped=true"
import script from "./ProjectSearchV2.vue?vue&type=script&lang=js"
export * from "./ProjectSearchV2.vue?vue&type=script&lang=js"

import "./ProjectSearchV2.vue?vue&type=style&index=0&id=546093de&scoped=true&lang=css"

import exportComponent from "/Users/joecortinhas/Documents/code/DigitalLaborSolutions/dlstracker_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546093de"]])

export default __exports__